import { useMemo, useState } from 'react';
import { useToggle } from 'react-use';

import { LoaderSpinner } from '@dreryk/react-components';

import { useCurrentHealthcarePracticeQuery } from './HealthcarePracticePanel.hooks';
import { HealthcarePracticeFormBean, mapHealthcarePracticeToBean } from './common/healthcarePractice';
import { HealthcarePracticeDataPanel } from './healthcarePracticeData/HealthcarePracticeDataPanel';
import { HealthcarePracticeUpdatePanel } from './healthcarePracticeUpdate/HealthcarePracticeUpdatePanel';

type HealthcarePracticePanelProps = {
   readonly verifyAccountConfiguration: () => Promise<void>;
};
export const HealthcarePracticePanel = (props: HealthcarePracticePanelProps): JSX.Element => {
   const { data, refetch: refetchHealthcarePractice } = useCurrentHealthcarePracticeQuery();
   const healthcarePractice = useMemo<HealthcarePracticeFormBean | null>(
      () => (data ? mapHealthcarePracticeToBean(data) : null),
      [data]
   );
   const [editableMode, toggleEditableMode] = useToggle(false);
   const [dataChanged, setDataChanged] = useState(false);

   if (!healthcarePractice) {
      return <LoaderSpinner />;
   }

   if (editableMode) {
      const onDataChanged = async (): Promise<void> => {
         setDataChanged(true);
         toggleEditableMode(false);
         await refetchHealthcarePractice();
         await props.verifyAccountConfiguration();
      };

      return (
         <HealthcarePracticeUpdatePanel
            onEditEnd={toggleEditableMode}
            onDataChanged={onDataChanged}
            healthcarePractice={healthcarePractice}
            verifyAccountConfiguration={props.verifyAccountConfiguration}
         />
      );
   }

   return (
      <HealthcarePracticeDataPanel
         onUpdateClicked={toggleEditableMode}
         healthcarePractice={healthcarePractice}
         dataChanged={dataChanged}
      />
   );
};
